import { createSelector } from "reselect";

import { loadingSelector } from "../../../redux/selectors/loading";
import { RootState } from "../../../redux/store";
import Store from "../../../redux/store";

import {
  CampaignBriefsState,
  ICampaignBriefsFilters,
  ICampaignBriefsFiltersState,
} from "../types/campaign-briefs.interface";

import * as actions from "./campaign-briefs.actions";

export const getCampaignBriefsState = (state: RootState): any => state.campaignBriefs;

export const getCampaignBriefsFilters = createSelector(
  getCampaignBriefsState,
  (state: CampaignBriefsState) => state.filters
);

export const getCampaignBriefsOwnersOptions = createSelector(
  getCampaignBriefsFilters,
  (filters: ICampaignBriefsFiltersState) => filters.briefOwners ?? []
);

export const getCampaignBriefsResults = createSelector(
  getCampaignBriefsState,
  (state: CampaignBriefsState) => state.results
);

export const getCampaignBriefsCount = createSelector(
  getCampaignBriefsState,
  (state: CampaignBriefsState) => state.count
);

export const getErrors = createSelector(
  getCampaignBriefsState,
  (state: CampaignBriefsState) => state.errors
);

export const getLoadingState = createSelector(
  getCampaignBriefsState,
  (state: CampaignBriefsState) => state.loading
);

export const getLoadingSelector = loadingSelector(getLoadingState);

export function fetchCampaignBriefs(filters: ICampaignBriefsFilters, changePage: boolean = false) {
  if (changePage) {
    Store.dispatch(actions.changePage(filters));
  } else {
    Store.dispatch(actions.fetch(filters));
  }
}

export function fetchCampaignBriefsFilters() {
  Store.dispatch(actions.fetchFilters());
}
